import { render, staticRenderFns } from "./JjVideoPlay.vue?vue&type=template&id=446d6b6e&scoped=true"
import script from "./JjVideoPlay.vue?vue&type=script&lang=js"
export * from "./JjVideoPlay.vue?vue&type=script&lang=js"
import style0 from "./JjVideoPlay.vue?vue&type=style&index=0&id=446d6b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d6b6e",
  null
  
)

export default component.exports